/**
 * Builds params for UserService.getUsers() to fetch users linked to a business.
 * Uses the standard getUsers endpoint (businessID is in its Joi schema).
 * Replaces the old ClientService.getBusinessContacts which was user-scoped
 * and returned empty for admin users.
 */
export function buildContactsParams(businessId: string): Record<string, any> {
  if (!businessId) return {};
  return { businessID: businessId, limit: 200 };
}
